import React from "react";
import { useSelector } from "react-redux";

import { useHandleWindowsSwitch } from "../CustomHooks";
import Window from "./Window";

const MainSceneWindow = () => {
  useHandleWindowsSwitch();

  var targetBuildingScene = useSelector(
    (state) => state.sceneVisibility.value[4]
  );
  if (!targetBuildingScene) return;
  return <Window />;
};

export default React.memo(MainSceneWindow);
